if(jQuery){
    (function ($) {
        $(document).ready(function() {
            var activeMenu = null;
            var mainNav = $('#main-nav');
            //当前类目
            if (typeof activeMenuClass != "undefined") {
                if ("" != activeMenuClass.categoryClass) {
                    var activeSubCategory = mainNav.find('a.' + activeMenuClass.categoryClass);
                    activeSubCategory.addClass('active');
                    activeMenu = mainNav.find('li.l0 p.active');
                    if (activeMenu.size() <= 0) {
                        activeMenu = activeSubCategory.last().closest('.l0').find('p').addClass('active');
                    }
                }
                if ("" != activeMenuClass.filterClass && activeMenu.size() > 0) {
                    activeMenu.next().find('.' + activeMenuClass.filterClass).addClass('active');
                }
            }

            function PcNavToggleShow() {
                var pcNavTimer = 0;
                var pcNavTopNode = mainNav.find('li.l0');

                function showNavChilds(dom, is_show) {
                    pcNavTimer = setTimeout(function () {
                        if (is_show) {
                            pcNavTopNode.find('p').removeClass("active");
                            pcNavTopNode.find('ul.l1').hide();
                            dom.find('p').addClass("active");
                            dom.find("ul.l1").show();
                        } else {
                            dom.find('p').removeClass("active");
                            dom.find("ul.l1").hide();
                        }
                    }, 200);
                }

                pcNavTopNode.on('mouseover', function (e) {
                    clearInterval(pcNavTimer);
                    var dom = $(this).find('p');
                    if (dom.hasClass("active")) {
                        return;
                    }
                    showNavChilds($(this), 1);
                });
                pcNavTopNode.on('mouseout', function () {
                    clearInterval(pcNavTimer);
                    showNavChilds($(this), 0);
                });
            }
            PcNavToggleShow();
        });
    })(jQuery);
}